import React from 'react';
import {UploadImage} from 'components/UI/Image';
import {Link} from 'react-router-dom';

class TopBusinessItem extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  render() {
    return (
      <div className="top-business-item">
        <div className='top-business-item-wrap-img'>
          <Link to={this.props.item.link} target='_blank'>
            <UploadImage transform="crop" type="BUSINESS" className='item-image' width="100" height="100" image={this.props.item.logo}/>
          </Link>
        </div>
      </div>
    );
  }
}

export default TopBusinessItem;



// WEBPACK FOOTER //
// ./components/home/sub-view/TopBusiness/TopBusinessItem.jsx